import axios from 'axios';
import { API_BASE_URL } from '@/config/api-config';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('parent_accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Response interceptor to handle authentication errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (typeof window !== 'undefined') {
      // Prevent redirect for specific auth recovery pages
      const currentPath = window.location.pathname;
      if (
        currentPath.includes('/reset-password') ||
        currentPath.includes('/forgot-password')
      ) {
        localStorage.removeItem('parent_accessToken');
        localStorage.removeItem('user');
        // Do not redirect, just clear data and reject the promise
        return Promise.reject(error);
      }

      // Only handle actual authentication errors, not authorization errors
      if (error.response?.status === 401) {
        console.warn(
          'Authentication failed - clearing token and redirecting to login',
        );

        // Clear auth data
        localStorage.removeItem('parent_accessToken');
        localStorage.removeItem('user');

        // Only redirect if not already on login page
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/parent/login';
        }
      }
    }
    return Promise.reject(error);
  },
);

export default api;
